<template>
  <button class="support-fab" type="button" title="Что-то не работает? Сообщите в IT" @click="openReport">
    <span class="support-fab__icon" aria-hidden="true">?</span>
    <span class="support-fab__text">Сообщить в IT</span>
  </button>
  <ReportToIT :open="open" :health="health" @close="open = false" />
</template>

<script setup>
import { ref } from 'vue'
import ReportToIT from '@/components/workspace/ReportToIT.vue'
import { fetchWorkspaceHealth } from '@/backend/workspaceApi'

const open = ref(false)
const health = ref(null)

async function openReport() {
  open.value = true
  try {
    health.value = await fetchWorkspaceHealth()
  } catch (e) {
    health.value = { overall: { state: 'down', text: `Сервер ERP не ответил: ${e?.message || 'нет связи'}` }, checks: [] }
  }
}
</script>

<style scoped>
.support-fab {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 1500;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #e5e7eb;
  border-radius: 9999px;
  background: #fff;
  color: #374151;
  padding: 8px 14px 8px 8px;
  font: inherit;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(17, 24, 39, 0.12);
  opacity: 0.85;
}
.support-fab:hover { opacity: 1; border-color: #4f46e5; color: #4f46e5; }
.support-fab__icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #4f46e5;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 640px) {
  .support-fab__text { display: none; }
  .support-fab { padding: 8px; }
}
</style>
